import { env } from './env';

export const EXTERNAL_LINKS = {
  TWITTER: 'https://x.com/nexhiroai',
  LINKEDIN: 'https://linkedin.com/company/nexhiro',
  GITHUB: 'https://github.com/NexHiro',
  CALENDLY_DEMO: env.NEXT_PUBLIC_CALENDLY_URL,
  BOOK_DEMO: '/book-demo',
  REQUEST_DEMO: '/book-demo',
  GET_STARTED: env.NEXT_PUBLIC_APP_URL || 'https://app.nexhiro.ai',
  CONTACT_SALES: `mailto:${env.NEXT_PUBLIC_CONTACT_EMAIL}`,
  APP_URL: env.NEXT_PUBLIC_APP_URL || 'https://app.nexhiro.ai',
} as const;
